import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
	selector: 'ms-menu',
	templateUrl: './ms-menu.component.html',
	styleUrls: ['./ms-menu.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsMenuComponent implements OnInit, OnDestroy {
	@Input({ required: true })
	icon: string;

	@Input({ required: true })
	items: MenuItem[] | undefined;

	@Input()
	popup: boolean = true;

	@Input()
	class: string;

	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
